import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {GroupModel} from "../../../models/group.model";
import * as _ from "lodash";
import * as angular from "angular";

require('./groups-color-display-list.scss');
@Component({
  standalone: false,
  selector: 'app-groups-color-display-list',
  templateUrl: './groups-color-display-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupsColorDisplayListComponent implements OnInit, OnChanges {

  @Input() groups?: GroupModel[];
  @Input() maxItems?: any = 3;

  public viewGroups: GroupModel[];
  public extraGroupsCount: any;
  public extraGroups: GroupModel[];
  public groupRGBAColorMap: any;


  constructor(@Inject('commonsService') private commonsService) {
  }

  ngOnInit() {
    this.viewGroups = [];
    this.initGroups(this.groups);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.groups && !changes.groups.isFirstChange()) {
      this.viewGroups = [];
      this.initGroups(this.groups);
    }
  }

  private initGroups(groups: GroupModel[]) {

    if (!this.groups?.length) {
      return;
    }

    this.groupRGBAColorMap = {};

    groups.forEach(g => {
      if (!!g.displayColor) {
        this.groupRGBAColorMap[g.id] = this.commonsService.hexToRGBColor(g.displayColor, 0.1)
      }
    })

    this.extraGroupsCount = undefined;

    if (_.get(groups, 'length')) {
      this.viewGroups = this.maxItems ? _.filter(groups, (item, index) => {
        return index < this.maxItems;
      }) : groups;

      if (groups.length > this.viewGroups.length) {
        this.extraGroupsCount = '+' + (groups.length - this.viewGroups.length).toString();
      }

      if (this.extraGroupsCount) {
        const tagsCopy = angular.copy(this.groups);
        this.extraGroups = tagsCopy.slice(this.viewGroups.length);
      }
    }
  }

}
